jQuery(document).ready(function($) {

  $(document).foundation();

  $('body').on('click', '#menu-open', function() {
    $(this).toggleClass('active');
    $('#menu-mobile').toggleClass('active');
    $('#menu-close').toggleClass('active');

    if ($('#search-open').hasClass('active')) {
      $('#search-open').toggleClass('active');
      $('#search-mobile').toggleClass('active');
      $('#search-close').toggleClass('active');
    }
  });

  $('body').on('click', '#menu-close', function() {
     $(this).toggleClass('active');
    $('#menu-mobile').toggleClass('active');
    $('#menu-open').toggleClass('active');
  });

  $('body').on('click', '#menu-mobile', function() {
    $('#menu-open').toggleClass('active');
    $('#menu-mobile').toggleClass('active');
    $('#menu-close').toggleClass('active');

  });

  $('body').on('click', '#search-open', function() {
    $(this).toggleClass('active');
    $('#search-mobile').toggleClass('active');
    $('#search-close').toggleClass('active');

    if ($('#menu-open').hasClass('active')) {
      $('#menu-open').toggleClass('active');
      $('#menu-mobile').toggleClass('active');
      $('#menu-close').toggleClass('active');
    }
  });

  $('body').on('click', '#search-close', function() {
    $(this).toggleClass('active');
    $('#search-open').toggleClass('active');
    $('#search-mobile').toggleClass('active');
  });

  //  $('body').on('click', '#search-mobile', function() {
  //   $('#search-open').toggleClass('active');
  //   $('#search-mobile').toggleClass('active');
  // });

  
  if ( $('body').hasClass('home') ) {
    $(document).on('scroll', function(){
      var scrollTop = $(window).scrollTop();
      if ( ( scrollTop != 0 ) && !( $('body').hasClass('scrolled') ) ) {
        $('body').addClass('scrolled');
      }
      else if( scrollTop == 0) {
        $('body').removeClass('scrolled');
      }
    });
    
  }




  // Select all links with hashes
$('.home-menu a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').delay(1200).animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
  }
});
  
  $('.pb-gallery-wrapper').slick({
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    adaptiveHeight: true,
    dots: false
  });

  $('.pb-gallery-thumbnails .thumbnail').on('click',function(e){
    var thm = $(this), index = thm.index(), gallery = thm.closest('.pb-gallery').find('.slick-slider');
    gallery.slick('slickGoTo',index);
  });

  // Remove empty P tags created by WP inside of Accordion and Orbit
  $('.accordion p:empty, .orbit p:empty').remove();

	// Makes sure last grid item floats left
	$('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
      $(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      $(this).wrap("<div class='flex-video'/>");
    }
  });

});
